import {isFunction} from 'underscore';

export function tryCall<S>(func: any | Function | (() => S)): S
export function tryCall<T, S>(func: (args?: T,) => S, args?: T): S
export function tryCall<T, T1, S>(func: (args?: T, args1?: T1) => S, args?: T, args1?: T1): S
export function tryCall<T, T1, T2, S>(func: (args?: T, args1?: T1, args2?: T2) => S, args?: T, args1?: T1, args2?: T2): S
export function tryCall<T, T1, T2, T3, S>(func: (args?: T, args1?: T1, args2?: T2, args3?: T3) => S, args?: T, args1?: T1, args2?: T2, args3?: T3): S | undefined {
	if (func && isFunction(func)) {
		try {
			return func(args, args1, args2, args3);
		} catch (e) {
			console.error(e);
		}
	}
}
